module.exports = __webpack_public_path__ + "img/fj.e3aab119.png";